export default __webpack_public_path__ + "static/stepTwoNecklaceImg-4dbb4ac521ecc8b1df898181aecb9c1b.jpg";